import { useState, useEffect } from "react";

export const useLightbox = (gallery) => {
  const [open, setOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [slides, setSlides] = useState([]);

  const fetchImageDimensions = (src) =>
    new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      };
      img.src = src;
    });

  useEffect(() => {
    if (!gallery?.content?.rendered) return;

    const observer = new MutationObserver((mutations, obs) => {
      const images = document.querySelectorAll("figure.wp-block-image img");
      if (images.length) {
        console.log("Found images:", images.length);
        obs.disconnect(); // stop observing
        initLightbox(images);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const handleClick = (event, index) => {
      setCurrentImage(index);
      setOpen(true);
    };

    const initLightbox = async (images) => {
      const slides = await Promise.all(
        Array.from(images).map(async (img, index) => {
          const originalSrc = img.src.replace(/-\d+x\d+(?=\.\w+$)/, "");
          const dims = await new Promise((res) => {
            const tmp = new Image();
            tmp.onload = () =>
              res({ width: tmp.naturalWidth, height: tmp.naturalHeight });
            tmp.src = originalSrc;
          });

          img.classList.add("hover:cursor-pointer");
          const handler = (e) => handleClick(e, index);
          img.addEventListener("click", handler);
          img._lightboxHandler = handler;

          return { src: originalSrc, width: dims.width, height: dims.height };
        })
      );
      setSlides(slides);
    };

    return () => observer.disconnect();
  }, [gallery]);

  const closeLightbox = () => setOpen(false);

  return {
    open,
    currentImage,
    slides,
    closeLightbox,
  };
};
